import { Link } from 'react-router-dom';

const quickLinks = [
  { label: 'Home', to: '/', external: false },
  { label: 'About Us', to: '/about', external: false },
  { label: 'Our Services', to: '/services', external: false },
  { label: 'Rentals', to: 'https://rentals.galaxyhousing.com.au', external: true },
  { label: 'Contact Us', to: '/contact', external: false },
  { label: 'Privacy Policy', to: '/privacy-policy', external: false },
];

export default function Footer() {
  return (
    <footer className="bg-navy-950 text-white">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        {/* Brand */}
        <div className="lg:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <img
              src="https://static.readdy.ai/image/18ca25ea8a69d5eb1e849ccadbb7687f/672c165fcb7ce82117b4150406656ead.jpeg"
              alt="Galaxy Housing"
              className="w-10 h-10 rounded-full object-cover"
            />
            <div>
              <p className="font-heading font-bold text-white text-base leading-tight">Galaxy Housing</p>
              <p className="text-gold-400 text-xs tracking-widest uppercase">Feel At Home, Wherever You Are</p>
            </div>
          </div>
          <p className="text-white/60 text-sm leading-relaxed mb-5">
            Providing clean, reliable, and affordable furnished accommodation across regional areas and metro cities in Australia. Your comfortable home away from home.
          </p>
          <div className="flex gap-3">
            <a
              href="https://www.facebook.com/GalaxyHousing"
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-gold-500 hover:text-navy-900 text-white/70 transition-all duration-200 cursor-pointer"
            >
              <i className="ri-facebook-fill text-sm" />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-sm font-semibold tracking-widest uppercase text-gold-400 mb-5">
            Quick Links
          </h4>
          <ul className="space-y-3">
            {quickLinks.map((link) => (
              <li key={link.to}>
                {link.external ? (
                  <a
                    href={link.to}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white/60 text-sm hover:text-gold-400 transition-colors cursor-pointer flex items-center gap-2"
                  >
                    <i className="ri-arrow-right-s-line text-xs" />
                    {link.label}
                  </a>
                ) : (
                  <Link
                    to={link.to}
                    className="text-white/60 text-sm hover:text-gold-400 transition-colors cursor-pointer flex items-center gap-2"
                  >
                    <i className="ri-arrow-right-s-line text-xs" />
                    {link.label}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div>
          <h4 className="text-sm font-semibold tracking-widest uppercase text-gold-400 mb-5">
            Our Services
          </h4>
          <ul className="space-y-3">
            {[
              'Furnished Private Rooms',
              'All Bills Included',
              'Free Unlimited Wi-Fi',
              'Fortnightly Cleaning',
              'Gardening Services',
              'Professional Management',
            ].map((s) => (
              <li key={s} className="text-white/60 text-sm flex items-center gap-2">
                <i className="ri-check-line text-gold-400 text-xs" />
                {s}
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-sm font-semibold tracking-widest uppercase text-gold-400 mb-5">
            Contact Us
          </h4>
          <ul className="space-y-4">
            <li className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                <i className="ri-phone-fill text-gold-400 text-sm" />
              </div>
              <div>
                <p className="text-white/40 text-xs uppercase tracking-wide mb-0.5">Phone</p>
                <a href="tel:0483944617" className="text-white/80 text-sm hover:text-gold-400 transition-colors cursor-pointer whitespace-nowrap">
                  0483 944 617
                </a>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                <i className="ri-mail-fill text-gold-400 text-sm" />
              </div>
              <div>
                <p className="text-white/40 text-xs uppercase tracking-wide mb-0.5">Email</p>
                <a href="mailto:rentals@galaxyhousing.com.au" className="text-white/80 text-sm hover:text-gold-400 transition-colors cursor-pointer">
                  rentals@galaxyhousing.com.au
                </a>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                <i className="ri-map-pin-fill text-gold-400 text-sm" />
              </div>
              <div>
                <p className="text-white/40 text-xs uppercase tracking-wide mb-0.5">Address</p>
                <p className="text-white/80 text-sm">PO Box 1035<br />Spit Junction NSW 2088</p>
              </div>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-xs">
            &copy; {new Date().getFullYear()} Galaxy Housing. All rights reserved. ABN registered in NSW, Australia.
          </p>
          <p className="text-white/30 text-xs">
            Affordable furnished accommodation &middot; Regional &amp; Metro Australia &middot; All-inclusive housing
          </p>
        </div>
      </div>
    </footer>
  );
}
